import React, { useState } from "react";
import { Button, Drawer, Form, Input, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import axiosConfig from "../../../util/axiosConfig";
import requestErrorHandler from "../../../util/requestErrorHandler";

const EditTruckProfile = ({ truckProfile, getCategory, category }: any) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  async function handleSubmit() {
    setIsLoading(true);
    await axiosConfig
      .put(
        `/truck-category/update-profile?profileId=${truckProfile.id}`,
        form.getFieldsValue()
      )
      .then((response: any) => {
        message.success("Category updated successfully");
        form.resetFields();
        setOpen(false);
        getCategory();
      })
      .catch((error) => {
        requestErrorHandler(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <>
      <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={() => setOpen(true)}
        style={{ background: "orange", borderColor: "orange" }}
      >
        Edit
      </Button>
      <Drawer
        title="Add Truck Category Category"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
      >
        <Form
          initialValues={truckProfile}
          className="w-100"
          onFinish={handleSubmit}
          form={form}
          layout="vertical"
        >
          <Form.Item
            name="type"
            label="Type"
            rules={[{ required: true, message: "Enter a valid type" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="tonnage"
            label="Tonnage"
            rules={[{ required: true, message: "Enter a valid tonnage" }]}
          >
            <Input />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={isLoading}
            className="bg-[#096DD9]"
          >
            Save
          </Button>
        </Form>
      </Drawer>
    </>
  );
};

export default EditTruckProfile;
